import React, { useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import { PageHeader } from './PublicLayout';
import contactHelpers from '../utils/contactValidation';
const { CONTACT_INITIAL, CONTACT_LIMITS, normalizeContact, validateContact }=contactHelpers;
const h=React.createElement;
export default function ContactUsGrid() {
  const [values,setValues]=useState({...CONTACT_INITIAL});
  const [errors,setErrors]=useState({});
  const [status,setStatus]=useState({type:'',message:''});
  const [sending,setSending]=useState(false);
  const submitting=useRef(false);
  const focusError=nextErrors=>{
    const key=Object.keys(nextErrors)[0];
    const field=document.getElementById('contact-'+key);
    if(field)field.focus();
  };
  const change=e=>{
    const {name,value}=e.target;
    setValues(previous=>({...previous,[name]:value}));
    setErrors(previous=>({...previous,[name]:undefined}));
    setStatus({type:'',message:''});
  };
  const submit=async e=>{
    e.preventDefault();
    if(submitting.current)return;
    const nextErrors=validateContact(values);
    setErrors(nextErrors);
    if(Object.keys(nextErrors).length){focusError(nextErrors);return;}
    submitting.current=true;setSending(true);setStatus({type:'',message:''});
    try {
      const response=await fetch('/api/sendContactEmail/MailContact',{
        method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(normalizeContact(values))
      });
      const data=await response.json().catch(()=>null);
      if(!response.ok||!data||data.success!==true){
        if(data&&data.errors){setErrors(data.errors);focusError(data.errors);}
        throw new Error('send_failed');
      }
      setValues({...CONTACT_INITIAL});
      setStatus({type:'success',message:'Your message has been sent. Thank you for getting in touch.'});
    } catch(error) {
      setStatus({type:'error',message:'Your message could not be sent. Your entries have been kept. Try again, or email info@entremap.online.'});
    } finally {submitting.current=false;setSending(false);}
  };
  const field=(name,label,type='text',extra={})=>{
    const id='contact-'+name;
    return h('div',{className:'emap-form-field',key:name},
      h('label',{htmlFor:id},label),
      h(name==='message'?'textarea':'input',{id,name,type:name==='message'?undefined:type,value:values[name],
        onChange:change,maxLength:CONTACT_LIMITS[name],required:['fullName','email','message'].includes(name),
        autoComplete:({fullName:'name',email:'email',phoneNumber:'tel'})[name],
        'aria-invalid':!!errors[name],'aria-describedby':errors[name]?id+'-error':undefined,...extra}),
      errors[name]&&h('p',{id:id+'-error',className:'emap-field-error'},errors[name]));
  };
  return h(React.Fragment,null,
    h(PageHeader,{eyebrow:'Contact EntreMap',title:'Let’s start',accent:'a conversation.',
      intro:'Questions about the assessment, support with your account, or an idea for using EntreMap in your organisation? We’d like to hear from you.'}),
    h('section',{className:'emap-container emap-contact-layout'},
      h('div',{className:'emap-contact-info'},
        h('p',{className:'emap-eyebrow'},'Get in touch'),
        h('h2',null,'A question. An idea.',h('br'),'A useful next step.'),
        h('p',null,'Use the form for general enquiries, assessment support or privacy and data requests.'),
        h('a',{className:'emap-contact-link',href:'mailto:info@entremap.online'},
          h('span',null,'Email us'),h('strong',null,'info@entremap.online'),h('span',{'aria-hidden':true},'↗')),
        h('a',{className:'emap-contact-link',href:'tel:+61406125111'},
          h('span',null,'Call us'),h('strong',null,'0406 125 111'),h('span',{'aria-hidden':true},'↗')),
        h('div',{className:'emap-support-card'},h('h3',null,'Looking for a completed assessment?'),
          h('p',null,'Sign in with the same account you used to complete it, then check Profile before taking it again.'),
          h(Link,{to:'/faq#faq-403',className:'emap-text-link'},'Read the troubleshooting advice →')),
        h('p',{className:'emap-small-note'},'For account support, include your sign-in method, the error text and approximate time. Do not send passwords or verification codes.')),
      h('div',{className:'emap-contact-form-card'},
        h('h2',null,'Send us a message'),
        h('p',{className:'emap-form-intro'},'All fields are required except phone number.'),
        status.message&&h('div',{className:'emap-form-status emap-form-status--'+status.type,
          role:status.type==='error'?'alert':'status','aria-live':'polite'},status.message),
        h('form',{onSubmit:submit,noValidate:true,'aria-busy':sending},
          h('fieldset',{disabled:sending,className:'emap-form-fields'},
            field('fullName','Name'),h('div',{className:'emap-form-row'},field('email','Email','email'),field('phoneNumber','Phone number (optional)','tel')),
            h('div',{className:'emap-form-field'},h('label',{htmlFor:'contact-subject'},'What can we help with?'),
              h('select',{id:'contact-subject',name:'subject',value:values.subject,onChange:change,
                'aria-invalid':!!errors.subject,'aria-describedby':errors.subject?'contact-subject-error':undefined,required:true},
                ['General enquiry','Login or account help','Assessment access','Results or report help','Institutional use','Privacy or data request']
                  .map(topic=>h('option',{value:topic,key:topic},topic))),
              errors.subject&&h('p',{id:'contact-subject-error',className:'emap-field-error'},errors.subject)),
            field('message','Message','text',{rows:6}),
            h('div',{className:'emap-honeypot','aria-hidden':true},
              h('label',{htmlFor:'contact-website'},'Leave this field empty'),
              h('input',{id:'contact-website',name:'website',value:values.website,onChange:change,tabIndex:-1,autoComplete:'off'})),
            h('p',{className:'emap-small-note'},'Read our ',h(Link,{to:'/privacypolicy'},'Privacy Policy'),' before sending personal information.'),
            h('button',{type:'submit',className:'emap-button'},sending?'Sending…':'Send message',h('span',{'aria-hidden':true},'→')))))));
}

